import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Filter, Image as ImageIcon, Search } from "lucide-react";

export default function ImagingPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
            Imagenología
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Listado general de estudios radiológicos y de diagnóstico por imagen.
          </p>
        </div>
        <Button className="w-full sm:w-auto">
          <ImageIcon className="h-4 w-4 mr-2" />
          Nuevo Estudio
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Filtros de Búsqueda</CardTitle>
          <CardDescription>
            Busca por paciente, ID de estudio o modalidad.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input className="pl-10" placeholder="Buscar estudios..." />
            </div>
            <Button variant="outline">
              <Filter className="h-4 w-4 mr-2" />
              Filtros Avanzados
            </Button>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="overflow-hidden hover:shadow-md transition-shadow">
            <div className="h-40 bg-gray-100 dark:bg-gray-800 flex items-center justify-center border-b">
              <ImageIcon className="h-12 w-12 text-gray-300" />
            </div>
            <CardHeader className="p-4">
              <CardTitle className="text-lg">Estudio #00{i}</CardTitle>
              <CardDescription>RX Tórax - Paciente Prueba {i}</CardDescription>
            </CardHeader>
            <CardContent className="p-4 pt-0">
              <p className="text-xs text-gray-500">Fecha: 09/03/2026</p>
              <Button
                variant="link"
                className="p-0 h-auto mt-2 text-primary font-semibold"
              >
                Ver detalles
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
